// TEMPORARY web32_scale_question experiment: one adhoc question asking whether
// the user owns a food scale (Jeremy, Aug 10). Teardown: delete this folder and
// its call sites in App.tsx, types.ts, and debugExperiment.ts.

export const WEB32_SCALE_EXPERIMENT_NAME = "web32_scale_question";
export const WEB32_SCALE_ARM_VARIATION = "variation";
export const WEB32_SCALE_ARM_CONTROL = "control";

// Answer values keep the intent readable in Amplitude: "no_prefer_not" is
// aversion to weighing food, not to owning a scale — that's the product signal.
const foodScaleQuestion = {
  name: "foodScale",
  title: "Do you have a food scale at home?",
  type: "radiogroup",
  choices: [
    { value: "yes_regular", text: "Yes, I use it regularly" },
    { value: "yes_rarely", text: "Yes, but I rarely use it" },
    { value: "no_will_get", text: "No, but I'll get one if required" },
    { value: "no_prefer_not", text: "No, and I'd rather not have to use one" },
  ],
  isRequired: true,
};

type QuizPage = {
  name: string;
  elements?: readonly unknown[];
  [key: string]: unknown;
};

const foodScalePage: QuizPage = {
  name: "foodScale",
  elements: [foodScaleQuestion],
};

// Inserted AFTER proteinSplash — the slot web32's nutritionApproach occupied,
// matching the Figma flow (frame "11b foodScale"). proteinSplash is a stable
// base-quiz page, so no section/progress special-casing is needed.
const ANCHOR_PAGE = "proteinSplash";

export function buildScaleQuestionPages<T extends QuizPage>(
  pages: readonly T[],
  enabled: boolean
): readonly T[] {
  if (!enabled) return pages;
  if (pages.some((p) => p.name === foodScalePage.name)) return pages;
  const i = pages.findIndex((p) => p.name === ANCHOR_PAGE);
  // Anchor missing (unexpected base-quiz change): fail open with no insert
  // rather than appending the question somewhere surprising.
  if (i === -1) return pages;
  const next = pages.slice() as T[];
  next.splice(i + 1, 0, foodScalePage as unknown as T);
  return next;
}
